import { render, staticRenderFns } from "./causeDetail.vue?vue&type=template&id=2d433e54"
import script from "./causeDetail.vue?vue&type=script&lang=js"
export * from "./causeDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports